import { render } from "./GuestLocaleDropdownMenu.vue?vue&type=template&id=4ad99960"
import script from "./GuestLocaleDropdownMenu.vue?vue&type=script&lang=js"
export * from "./GuestLocaleDropdownMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__